/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../../icon/icon'

const WhatsappIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M19.795 3.197A10.91 10.91 0 0012.045 0C6.009 0 1.096 4.89 1.093 10.9a10.842 10.842 0 001.462 5.451L1 22.001l5.807-1.517a10.986 10.986 0 005.235 1.327h.004c6.037 0 10.952-4.89 10.954-10.901a10.81 10.81 0 00-3.205-7.713zM12 19.937h-.004c-1.6 0-3.171-.43-4.548-1.245L7.12 18.5l-3.382.887.902-3.297-.212-.338a8.91 8.91 0 01-1.366-4.755c.001-4.926 4.01-8.933 8.94-8.933a8.94 8.94 0 018.935 8.94c-.002 4.927-4.012 8.935-8.938 8.935zm4.942-6.408c-.27-.137-1.601-.798-1.85-.889-.247-.091-.428-.137-.608.137-.18.273-.7.89-.857 1.071-.158.183-.316.206-.587.069-.27-.137-1.142-.426-2.176-1.357-.805-.724-1.348-1.62-1.506-1.893-.158-.274-.017-.421.119-.558.122-.122.27-.319.406-.479.135-.16.18-.273.27-.455.09-.183.046-.343-.022-.48-.068-.136-.609-1.481-.834-2.029-.22-.533-.443-.46-.61-.469-.157-.008-.338-.01-.518-.01a.99.99 0 00-.722.343c-.248.273-.947.934-.947 2.28 0 1.345.97 2.644 1.105 2.827.135.182 1.909 2.943 4.623 4.127.504.219 1.02.411 1.543.575.649.208 1.239.179 1.705.109.52-.079 1.601-.661 1.827-1.3.225-.638.225-1.186.158-1.3-.068-.114-.248-.182-.52-.319z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
WhatsappIconSvg.displayName = 'WhatsappIconSvg'

const WhatsappIcon = forwardRef((props, ref) => <Icon component={WhatsappIconSvg} ref={ref} {...props} />)
WhatsappIcon.displayName = 'WhatsappIcon'

WhatsappIcon.defaultProps = {
	...Icon.defaultProps,
}
WhatsappIcon.propTypes = {
	...Icon.propTypes,
}

export default WhatsappIcon
export { WhatsappIconSvg }
